import { useEffect, useState } from "react";

import { PackageProps } from "../../../../../domain/models/package.model";
import {
  SolicitationProps,
  typeRequest,
} from "../../../../../domain/models/solicitation.model";
import { StackModel } from "../../../../../domain/models/stacks";

import { especialTaxTypeList, taxTypeList } from "../../../../../utils";
import { getStack } from "../../customer/form/fields";

import { settings } from "../../../../../main/configs/settings";

export const Fields = (
  data: SolicitationProps | undefined,
  stackList: StackModel[] | undefined,
  packageList: PackageProps[] | undefined
): any[] => {
  const [stacks, setStacks] = useState<any>([]);

  useEffect(() => {
    if (data?.developer?.otherStack) {
      setStacks(
        data?.developer?.otherStack
          .split(", ")
          .map((item) => ({ id: item, text: item }))
      );
    }
  }, [data]);

  const blackList = {
    [typeRequest.COMPANY_REGISTER]: ["PERSONALDATA", "ADDRESS", "PLAN"],
    [typeRequest.BASIC_REGISTER]: [
      "PERSONALDATA",
      "ADDRESS",
      "COMPANY",
      "ADDRESS_COMPANY",
    ],
    [typeRequest.PACKAGE]: [
      "PERSONALDATA",
      "ADDRESS",
      "COMPANY",
      "ADDRESS_COMPANY",
    ],
    [typeRequest.COMPANY]: ["PERSONALDATA", "ADDRESS", "PLAN"],
  };

  const discriminatorFields = (
    type: any,
    blockName: any | undefined
  ): boolean => {
    if (!type) return true;
    if (blackList[type].includes(blockName)) return false;
    return true;
  };

  return [
    {
      groupName: "PERSONALDATA",
      groupLabel: "Dados pessoais:",
      hide: discriminatorFields(data?.type, "PERSONALDATA"),
      items: [
        {
          name: "name",
          type: "text",
          label: "Nome",
          disabled: true,
          defaultValue: data?.developer?.name,
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "cpf",
          type: "text",
          label: "CPF:",
          disabled: true,
          mask: "000.000.000-00",
          defaultValue: data?.developer?.cpf,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "email",
          type: "text",
          label: "E-mail:",
          disabled: true,
          defaultValue: data?.developer?.email,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "telefone",
          type: "text",
          label: "Telefone:",
          disabled: true,
          mask: "(00) 90000-0000",
          defaultValue: `(${data?.developer?.phone?.ddd}) ${data?.developer?.phone?.number}`,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "stack",
          type: "checkboxGroup",
          label: "Stack:",
          disabled: true,
          defaultValue: getStack(data?.developer?.stacks),
          options: stackList?.map((el) => ({
            value: el.id,
            label: el.description,
          })),
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "otherStack",
          type: "multipleValueText",
          label: "Outra Stack:",
          disabled: true,
          defaultValue: stacks,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "ADDRESS",
      groupLabel: "Endereço Residencial:",
      hide: discriminatorFields(data?.type, "ADDRESS"),
      items: [
        {
          name: "zipCode",
          type: "text",
          label: "CEP:",
          disabled: true,
          mask: "00000-000",
          defaultValue: data?.developerCompany?.developer?.address?.zipCode,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "address",
          type: "text",
          label: "Endereço",
          disabled: true,
          defaultValue: data?.developer?.address?.place,
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "number",
          type: "text",
          label: "Número:",
          disabled: true,
          defaultValue: data?.developer?.address?.number,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "district",
          type: "text",
          label: "Bairro:",
          disabled: true,
          defaultValue: data?.developer?.address?.district,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "complement",
          type: "text",
          label: "Complemento:",
          disabled: true,
          defaultValue: data?.developer?.address?.complement,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "state",
          type: "text",
          label: "Estado:",
          disabled: true,
          defaultValue: data?.developerCompany?.developer?.address?.state,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "text",
          label: "Cidade:",
          disabled: true,
          defaultValue: data?.developerCompany?.developer?.address?.city,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "COMPANY",
      hide: discriminatorFields(data?.type, "COMPANY"),
      groupLabel: "Dados CNPJ:",
      items: [
        {
          name: "socialReason",
          type: "text",
          label: "Razão Social",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.socialReason,
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "subscriptionNumber",
          type: "text",
          label: "CNPJ:",
          disabled: true,
          mask: "00.000.000/0000-00",
          defaultValue: data?.developerCompany?.company?.subscriptionNumber,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "stateRegistration",
          type: "text",
          label: "Inscrição Estadual:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.stateRegistration,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "municipalRegistration",
          type: "text",
          label: "Inscrição Municipal:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.municipalRegistration,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "fantasyName",
          type: "text",
          label: "Nome Fantasia",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.fantasyName,
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "emailCompany",
          type: "text",
          label: "E-mail Cadastrado:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.email,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "telefoneCompany",
          type: "text",
          label: "Telefone:",
          disabled: true,
          mask: "(00) 90000-0000",
          defaultValue: `(${data?.developerCompany?.company?.phone?.ddd}) ${data?.developerCompany?.company?.phone?.number}`,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "taxType",
          type: "select",
          label: "Regime Tributário:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.taxType,
          options: taxTypeList.map((el) => ({
            value: el.ENUM,
            label: el.label,
          })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "especialTaxType",
          type: "select",
          label: "Regime Tributário especial:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.especialTaxType,
          options: especialTaxTypeList.map((el) => ({
            value: el.ENUM,
            label: el.label,
          })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "simpleNacional",
          type: "checkbox",
          label: "Optante pelo SIMPLES Nacional:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.simpleNacional,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "culturalIncentive",
          type: "checkbox",
          label: "Incentivo a Cultura:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.culturalIncentive,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "taxIncentive",
          type: "checkbox",
          label: "Taxa de incentivo:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.taxIncentive,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "certificate",
          type: "file",
          icon: "upload",
          label: "Certificado digital:",
          disabled: true,
          defaultValue:
            data?.developerCompany?.company?.certificate &&
            `${settings.ASSETS_URL}/${data?.developerCompany?.company?.certificate?.url}`,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "ADDRESS_COMPANY",
      hide: discriminatorFields(data?.type, "ADDRESS_COMPANY"),
      groupLabel: "Endereço do CNPJ:",
      items: [
        {
          name: "zipCodeCompany",
          type: "text",
          label: "CEP:",
          disabled: true,
          mask: "00000-000",
          defaultValue: data?.developerCompany?.company?.address?.zipCode,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "addressCompany",
          type: "text",
          label: "Endereço",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.address?.place,
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "numberCompany",
          type: "text",
          label: "Número:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.address?.number,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "districtCompany",
          type: "text",
          label: "Bairro:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.address?.district,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "complementCompany",
          type: "text",
          label: "Complemento:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.address?.complement,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "stateCompany",
          type: "text",
          label: "Estado:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.address?.state,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "cityCompany",
          type: "text",
          label: "Cidade:",
          disabled: true,
          defaultValue: data?.developerCompany?.company?.address?.city,
          // disabled: true,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "PLAN",
      groupLabel: "Plano:",
      hide: discriminatorFields(data?.type, "PLAN"),
      items: [
        {
          name: "package",
          type: "select",
          label: "Plano:",
          defaultValue: data?.developerPackage?.pack?.id,
          options: packageList?.map((el) => ({
            value: el?.id,
            label: el.packageEnum,
          })),
          disabled: true,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "status",
          type: "select",
          label: "Status:",
          defaultValue: data?.developerPackage?.status,
          disabled: true,
          options: [
            { value: "PAYMENT_CONFIRMED", label: "Pagamento confirmado" },
            { value: "PENDING_PAYMENT", label: "Pagamento pendente" },
          ],
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
  ];
};
